import SSBOT_EXT_1 from "./SSBOT_EXT_1";
export default {
  SSBOT_EXT_1,
};
